export default "__VITE_ASSET__Aa6mWsYd__"